module.exports = "/_next/static/images/DeliveryCentrifuge@2x-ae980a532ca6d27a9c2cbca2dda7809f.png";